import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const SharePromptEmailBody = declareStringWithPlaceholders(
  "promptLibrary.sharePromptEmailBody",
  {
    text: ({ promptLink }) =>
      `Here’s a prompt I discovered in Copilot Lab. Click to see the details and try it yourself! ${promptLink}`,
    comment:
      "The email body for when users click on the Share via Email button to share a Copilot prompt with someone else. 'prompts' is the text input provided to AI model like GPT.",
    placeholders: {
      promptLink: "The permanent link to the Copilot Prompt",
    },
  }
);

export const SharePromptEmailBodyV2 = declareStringWithPlaceholders(
  "promptLibrary.sharePromptEmailBodyV2",
  {
    text: ({ promptLink }) =>
      `Here’s a prompt I discovered in Copilot Prompt Gallery. Click to see the details and try it yourself! ${promptLink}`,
    comment:
      "The email body for when users click on the Share via Email button to share a Copilot prompt with someone else. 'prompts' is the text input provided to AI model like GPT.",
    placeholders: {
      promptLink: "The permanent link to the Copilot Prompt",
    },
  }
);

export const SharePromptPrettifiedBizChatLinkWithTitle =
  declareStringWithPlaceholders(
    "promptLibrary.sharePromptPrettifiedBizChatLinkWithTitle",
    {
      text: ({ promptTitle }) =>
        `Try this prompt in Copilot for Microsoft 365: ${promptTitle}`,
      comment:
        "Prettified link for sharing an M365 BizChat prompt in Copilot with title",
      placeholders: { promptTitle: "The Prompt Title" },
    }
  );

export const SharePromptPrettifiedBizChatLinkWithoutTitle = declareString(
  "promptLibrary.sharePromptPrettifiedBizChatLinkWithoutTitle",
  {
    text: "Check out this prompt I made in Copilot!",
    comment:
      "Prettified link for sharing an M365 BizChat prompt in Copilot without title",
  }
);

export const SharePromptPrettifiedLinkWithTitle = declareStringWithPlaceholders(
  "promptLibrary.sharePromptPrettifiedLinkWithTitle",
  {
    text: ({ promptTitle }) =>
      `Check out this prompt in Copilot Lab: ${promptTitle}`,
    comment: "Prettified link for sharing a prompt in Copilot with title",
    placeholders: { promptTitle: "The Prompt Title" },
  }
);

export const SharePromptPrettifiedLinkWithTitleV2 =
  declareStringWithPlaceholders(
    "promptLibrary.sharePromptPrettifiedLinkWithTitleV2",
    {
      text: ({ promptTitle }) =>
        `Check out this prompt in Copilot Prompt Gallery: ${promptTitle}`,
      comment: "Prettified link for sharing a prompt in Copilot with title",
      placeholders: { promptTitle: "The Prompt Title" },
    }
  );
